export default {
  "site_name": "Yoybuy Sheet",
  "site_tagline": "Таблицы для шоппинга",
  "hero_title": "Yoybuy Sheet — Ваш гид по лучшим находкам",
  "hero_subtitle": "Полные таблицы со ссылками на товары для шоппинга через Yoybuy. Найдите лучшие товары по лучшим ценам.",
  "btn_yoybuy_sheet": "Yoybuy Sheet",
  "btn_buy_now": "Купить сейчас",
  "categories_title": "Категории товаров",
  "categories_subtitle": "Выберите категорию, чтобы перейти к таблице с товарами",
  "category_select_placeholder": "Выберите категорию...",
  "about_title": "Что такое Yoybuy Sheet?",
  "about_text_1": "Yoybuy Sheet — это подробные таблицы со ссылками на лучшие товары, доступные для заказа через Yoybuy. Каждая таблица содержит проверенные ссылки на качественные товары от надёжных продавцов.",
  "about_text_2": "Наши таблицы охватывают широкий спектр категорий: от обуви и одежды до аксессуаров и парфюмерии. Мы постоянно обновляем списки, чтобы вы всегда имели доступ к самым актуальным находкам.",
  "about_text_3": "Yoybuy — это удобный агент для заказа товаров из Китая. С нашими таблицами вы можете быстро находить нужные товары и оформлять заказы без лишних хлопот.",
  "why_title": "Почему стоит использовать наши таблицы?",
  "why_item_1_title": "Проверенные ссылки",
  "why_item_1_desc": "Все ссылки проходят проверку качества. Только надёжные продавцы и качественные товары.",
  "why_item_2_title": "Регулярные обновления",
  "why_item_2_desc": "Таблицы обновляются каждую неделю. Новые находки, новые тренды, новые бренды.",
  "why_item_3_title": "Широкий выбор",
  "why_item_3_desc": "14 категорий товаров: от кроссовок до парфюмерии. Всё, что вам нужно, в одном месте.",
  "why_item_4_title": "Экономия времени",
  "why_item_4_desc": "Не тратьте часы на поиски. Мы уже собрали лучшее для вас в удобных таблицах.",
  "guide_title": "Полное руководство по Yoybuy Sheet",
  "guide_desc": "Узнайте всё о том, как использовать таблицы Yoybuy для максимально выгодного шоппинга. Подробный гайд для начинающих и опытных пользователей.",
  "guide_btn": "Читать руководство",
  "footer_text": "Yoybuy Sheet — ваш надёжный помощник в мире шоппинга. Все ссылки ведут на проверенные таблицы с товарами.",
  "footer_copyright": "© 2026 Yoybuy Sheet. Все права защищены.",
  "categories": {
    "shoes": "Обувь",
    "hoodies": "Худи и Свитера",
    "tshirts": "Футболки",
    "jackets": "Куртки",
    "pants": "Брюки и Шорты",
    "headwear": "Головные уборы",
    "sets": "Комплекты",
    "underwear": "Нижнее бельё",
    "jersey": "Джерси",
    "accessories": "Аксессуары",
    "bags": "Сумки",
    "belts": "Ремни",
    "perfumes": "Парфюмерия",
    "other": "Разное"
  }
}